export default __webpack_public_path__ + "static/media/dizzy-spirits-md.f8453095.png";